<template>
  <!-- 拨号中 -->
  <div class="calling">
    <div>正在呼叫：{{ phoneNum }}</div>
    <el-button type="primary" size="small" @click="cancelCall">取消</el-button>
  </div>
</template>

<script>
import { hangUpApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'Calling',
  props: ['phoneNum'],
  methods: {
    async cancelCall() {
      await hangUpApi({
        phone: this.phoneNum,
      });
      this.$emit('cancelCall');
    },
  },
};
</script>

<style lang="scss" scoped>
.calling {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border: solid 1px #dcdfe6;
  padding: 10px;
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
}
</style>
